import { cn } from '@/lib/utils';

/**
 * The storefront's single loading placeholder.
 *
 * Shimmer, not pulse: every storefront loading state uses this sweep, so a
 * hand-rolled `animate-pulse` block reads as a different kind of loading and
 * makes the app feel stitched together. Reach for this rather than rolling a
 * placeholder by hand. (Admin is a separate system with its own skeleton —
 * see components/ui/skeleton.tsx.)
 *
 * Use it for content that has not arrived yet. An action already in flight on
 * a control the user just pressed wants a spinner instead — see Button's
 * `loading` prop.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        // bg-subtle, not a hardcoded grey: the old bg-border/60 ignored the
        // theme entirely and stayed light-grey in dark mode.
        'rounded-md bg-subtle relative overflow-hidden',
        'before:absolute before:inset-0 before:animate-shimmer',
        'before:bg-gradient-to-r before:from-transparent before:via-white/50 before:to-transparent',
        'before:bg-[length:200%_100%]',
        className,
      )}
    />
  );
}
